import { ButtonGroup, HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useFormState } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { GenerateRenButton } from '../../common/components/generate-ren-button';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { ReactivateEventButton } from '../../common/components/reactivate-event-button';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { countDirtyFields } from '../count-dirty-fields';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { EventExportButton } from './event-export-button';
import { EventWithDirtyFieldsFooter } from './event-with-dirty-fields-footer';

const ClearedEventBaseFooter = observer(function ClearedEventBaseFooter() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const enabledFeatures = useEnabledFeatures();
    const metadata = useEventMetadataStore();
    const agencyEventNumber = metadata.state.metadata?.agencyEventNumber;

    return eventId ? (
        <HStack w="100%">
            {enabledFeatures.canReactivateEvent && <ReactivateEventButton eventId={eventId} />}
            <ButtonGroup style={{ flex: 1, justifyContent: 'flex-end' }}>
                <GenerateRenButton eventId={eventId} />
                {agencyEventNumber && (
                    <EventExportButton eventId={eventId} eventNumber={agencyEventNumber} />
                )}
            </ButtonGroup>
        </HStack>
    ) : null;
});

export const ClearedEventFooter = observer(function ClearedEventFooter() {
    const { editClearedEvents } = useEnabledFeatures();
    const eventForm = useIntegratedForm<EventPanelFormType>();
    const { dirtyFields } = useFormState({
        control: eventForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);
    return editClearedEvents && dirtyFieldCount > 0 ? (
        <EventWithDirtyFieldsFooter dirtyFieldCount={dirtyFieldCount} />
    ) : (
        <ClearedEventBaseFooter />
    );
});
